import axiosInstance from "../../../config/axios-config"

export const GetLogo = async ({filename}) => {
    try {
        const response = await axiosInstance.get(`/api/v1/tenants/photo/${filename}`, {
            responseType: "blob",
        })
        return URL.createObjectURL(response.data)
    } catch (err) {
        console.error("Error fetching logo:", err)
        return null
    }
};

export const UploadLogo = async ({id, file}) => {
    const formData = new FormData()
    formData.append("file", file)
    const response = await axiosInstance.post(`/api/v1/tenants/photo/${id}`, formData, {
        headers: {"Content-Type": "multipart/form-data"},
    })
    return response.data
};

export const DeleteLogo = async ({id}) => {
    const response = await axiosInstance.delete(`/api/v1/tenants/photo/${id}`)
    return response.data
};
